// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2AMA-","inputDescription":"styles_inputDescription__2ZdfP"};